var map = {
	"./Avatar.png": 6687,
	"./Banner2.png": 9416,
	"./Bct-White 2.png": 8708,
	"./Ellipse882.png": 2817,
	"./Frame42875.png": 3373,
	"./Frame42876.png": 481,
	"./Group43093.png": 631,
	"./Rectangle1485.png": 4485,
	"./Rectangle1486.png": 3090,
	"./Rectangle1487.png": 4743,
	"./Rectangle1488.png": 8192,
	"./Rectangle1489.png": 4323,
	"./Rectangle1492.png": 9226,
	"./Rectangle1493.png": 826,
	"./Rectangle1494.png": 7219,
	"./Rectangle1495.png": 21,
	"./Rectangle8.png": 4427,
	"./Sansation_Regular.ttf": 9236,
	"./Section.png": 3362,
	"./about1.png": 9492,
	"./about2.png": 9935,
	"./about3.png": 8548,
	"./addcomment.png": 6744,
	"./amico-login.png": 1421,
	"./amico.png": 5792,
	"./amico1.png": 582,
	"./amico2.png": 939,
	"./approved.png": 5442,
	"./arrow.png": 7139,
	"./arrowdown.png": 5588,
	"./arrowright.png": 6144,
	"./avatar3.png": 5664,
	"./banner.png": 2962,
	"./blog.png": 9966,
	"./briefcase.png": 4184,
	"./calendar.png": 3165,
	"./cancel.png": 7160,
	"./category.png": 3793,
	"./certicatesimg.png": 1345,
	"./certificate-bg.png": 574,
	"./certificate.png": 2126,
	"./character-1.png": 1267,
	"./chat-2.png": 4240,
	"./choose.svg": 8975,
	"./coffetti.gif": 5919,
	"./comment.png": 970,
	"./commentavatar.png": 1429,
	"./confirm.svg": 1565,
	"./contact.png": 8125,
	"./coursedone.png": 4322,
	"./coursehero.png": 8746,
	"./coursehero2.png": 4131,
	"./courses.png": 4864,
	"./courseshero.png": 8130,
	"./coursesimg.png": 3411,
	"./developer.png": 8058,
	"./developerimg.png": 6262,
	"./digitalmark.png": 3051,
	"./digitalmark1.png": 6937,
	"./done.gif": 6218,
	"./done.png": 3013,
	"./done1.png": 4391,
	"./downloaded.png": 8332,
	"./dropdown.png": 6711,
	"./duration.png": 7995,
	"./edit.png": 2178,
	"./edunew.gif": 3258,
	"./email.png": 3005,
	"./email2.png": 8976,
	"./emoji.png": 6357,
	"./empty.png": 124,
	"./enrollimg.png": 7896,
	"./faqbg.svg": 2470,
	"./feedback.png": 6926,
	"./female.png": 3738,
	"./financial.webp": 5650,
	"./google.png": 2553,
	"./graduation-cap.png": 2923,
	"./graphic_design_header_venngage_blog.png": 9368,
	"./herobg.svg": 5057,
	"./herogif.gif": 9333,
	"./hide.png": 9196,
	"./how.gif": 7339,
	"./howbanner.png": 1402,
	"./howmain.png": 292,
	"./icons8-cancel.gif": 1247,
	"./image369(1).png": 8142,
	"./image369(2).png": 7650,
	"./image376.png": 6617,
	"./instructor.png": 5115,
	"./later.png": 7293,
	"./line.png": 5621,
	"./loginbg.jpg": 7513,
	"./logo-white.png": 1404,
	"./logo.png": 6949,
	"./logo2.png": 1637,
	"./logodark.svg": 5234,
	"./man.png": 4612,
	"./map.png": 1377,
	"./marketing.png": 553,
	"./media.png": 8784,
	"./message-tone-checked-off.mp3": 3248,
	"./microphone.png": 9937,
	"./microsoft.png": 9933,
	"./minical.png": 3805,
	"./miniclock.png": 6810,
	"./module.png": 6524,
	"./moduleprofile.png": 3547,
	"./notification.png": 5569,
	"./otp.png": 9147,
	"./pace.png": 595,
	"./password.png": 2192,
	"./payment.svg": 5197,
	"./paypal.png": 2108,
	"./performance.png": 544,
	"./phone.png": 9156,
	"./phone2.png": 3816,
	"./pick.svg": 4381,
	"./plain.png": 2901,
	"./preview.png": 897,
	"./previewlist.png": 1220,
	"./profile.png": 4254,
	"./quote.png": 4352,
	"./react.svg": 7256,
	"./reply.png": 3461,
	"./reset.gif": 2048,
	"./reset.png": 6901,
	"./review.png": 4093,
	"./segoe.ttf": 9514,
	"./send.png": 1037,
	"./session.png": 401,
	"./sessiondone.gif": 7348,
	"./sessionicon1.png": 491,
	"./sessionicon2.png": 471,
	"./sessionicon3.png": 2356,
	"./sessionicon4.png": 3492,
	"./show.png": 224,
	"./sign.svg": 6371,
	"./star.png": 6101,
	"./students.png": 9407,
	"./success-icon.png": 1212,
	"./tech.png": 1229,
	"./tech1.png": 5931,
	"./tech2.png": 7394,
	"./trophy-winner.gif": 7903,
	"./trophy.png": 7826,
	"./uiux.png": 8931,
	"./uiux1.png": 8776,
	"./uiux2.png": 1557,
	"./uiux3.png": 5003,
	"./video.png": 9235,
	"./view.svg": 4987,
	"./why1.png": 4114,
	"./why2.png": 1808,
	"./why3.png": 9970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;